import axios from 'AxiosInstance'
import routes from 'features/routes'

export default (userName, password) =>
  axios.post(routes.apiLogin, {userName, password})
